import { style } from "@vanilla-extract/css";
import { primitiveTokens, semanticThemeTokens } from "../theme/ThemeTokens.css";

export const labelRow = style({
  display: "flex",
  flex: "1 0 0",
  padding: `${primitiveTokens.sizing["1x"]} ${primitiveTokens.sizing["0x"]}`,
  fontSize: primitiveTokens.type.xs,
  lineHeight: "normal",
  color: semanticThemeTokens.label.color.regular,
  alignContent: "center",
  justifyContent: "space-between",
  alignItems: "center",
  alignSelf: "stretch"
});

export const optionalText = style({
  color: semanticThemeTokens.label.color.optionalRegular
});

export const labelDisabled = style({
  color: semanticThemeTokens.label.color.disabled
});
export const labelOptionalDisabled = style({
  color: semanticThemeTokens.label.color.optionalDisabled
});
